<script>
/**
 * 処理後物の大分類
 */

import {mapActions} from "vuex";
import InfiniteAutocomplete from "@/driver/components/InfiniteAutocomplete.vue";

export default {
  name: "InfiniteAfterDisposalItemCategoryAutoComplete",
  components: {
    InfiniteAutocomplete,
  },
  props: {
    /** 処理後物の大分類名 */
    categoryName: {
      type: String,
      default: null
    },
    /**
     * after_industrial: 廃棄物, after_recycling: 再資源化物
     */
    afterType: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: "処分後物の大分類",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    classes: {
      type: String,
      default: null,
    },

  },
  data() {
    return {
      loading: false,
      searchKeyword: null,
      timerId: undefined,
      pageNumber: 0,
      members: [],
      pagination: {
        next_page: null,
        prev_page: null,
        is_first_page: false,
        is_last_page: false,
      },
      workableName: null,
    };
  },
  computed: {},
  watch: {

    /**
     * 処理後物の大分類名の変更検知
     */
    categoryName(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.loadMembers(newValue);
      }
    },

    /**
     * 作業用処理後物の大分類名の変更検知
     */
    workableName() {
      this.returnValues();
    },

    afterType() {
      this.clearCallback();
    }
  },

  /**
   * 画面ロード時に呼ばれる.
   * ここで初期設定などを行う.
   */
  created() {
    if (this.categoryName) {
      this.workableName = this.categoryName;
      this.loadMembers(this.workableName);
    } else {
      this.fetchMembers();
    }
  },

  methods: {

    /**
     * 処理後物の大分類
     */
    ...mapActions("DriverMasterSearchAfterDisposalItemCategory", {
      fetchAfterDisposalItemCategories: 'index',
    }),

    /**
     * クリア コールバック
     */
    clearCallback() {
      this.workableName = null;
      this.$emit("update:values", null);
      this.reloadMembers();
    },

    /**
     * 初期ロード, 連動時に実行する.
     */
    loadMembers(value) {
      const conditions = {
        after_type: this.afterType,
        category_name: value,
        page: 1,
      };
      this.fetchAfterDisposalItemCategories({ ...conditions }).then((response) => {
        this.members = response.after_disposal_items;
        if (this.members.length === 1) {
          this.workableName = this.members[0].text;
        } else {
          this.workableName = null;
        }
        this.pagination = response.pagination;
        this.pageNumber = response.pagination.current_page;
      });
    },

    /**
     * リロード処理
     */
    reloadMembers() {
      this.searchKeyword = null;
      this.pageNumber = 0;
      this.members = [];
      Object.assign( this.$data.pagination, this.$options.data().pagination );
      this.fetchMembers();
    },

    /**
     * 取得アクション
     * @returns {Promise<unknown>}
     */
    fetchMembers() {
      this.loading = true;
      const conditions = {
        after_type: this.afterType,
        query: this.searchKeyword ,
        page: this.pageNumber,
      };
      this.fetchAfterDisposalItemCategories({ ...conditions }).then((response) => {
        this.members = this.members.concat(response.after_disposal_items);
        this.pagination = response.pagination;
        this.pageNumber = response.pagination.current_page;
      }).finally(() => {
        this.loading = false;
      });
    },

    /**
     * 次ページ読込
     */
    insectCallback() {
      if (this.pageNumber > 0) {
        this.pageNumber++;
        this.fetchMembers();
      }
    },

    /**
     * エンターキー キーダウンコールバック
     * @param value
     */
    enterKeydownCallback (value) {
      this.pageNumber = 0;
      this.searchKeyword = value;
      this.fetchMembers();
    },

    /**
     * 呼び出し元への戻し
     */
    returnValues() {
      if (this.members.length > 0) {
        const object = this.members.find((member) => member.text === this.workableName);
        this.$emit("update:values", object);
      }
    },
  },
}
</script>

<template>
  <validation-provider
    v-slot="{ errors }"
    :value="workableName"
    :rules="{ required: required }"
    :class="{ requiredMark: required }"
    :name="label"
  >
    <infinite-autocomplete
      v-model="workableName"
      :classes="classes"
      :disabled="disabled"
      :error-messages="errors"
      :label="label"
      :loading="loading"
      :members="members"
      :pagination="pagination"
      :rounded="rounded"
      @click:clear="clearCallback"
      @insect="insectCallback"
      @keydown:enter="enterKeydownCallback"
    >
      <template v-slot:item="{ item }">
        <v-chip
          small
          :color="item.after_type === 'after_industrial' ? 'light-blue lighten-4' : 'light-green lighten-4'"
        >
          {{ item.after_type === 'after_industrial' ? '廃棄物' : '再資源' }}
        </v-chip>
          <span class="ml-3">{{ item.text }}</span>
      </template>
    </infinite-autocomplete>
  </validation-provider>
</template>

<style scoped lang="scss">

</style>
